import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import uniqBy from 'lodash/uniqBy'

import useWallet from 'hooks/useWallet'
import { saveActivePools } from 'state/users/actions'
import { getContributedPoolList } from 'api'

const useContributedPoolList = (initialFetch = true) => {
  const _isMounted = useRef(true)
  const dispatch = useDispatch()
  const { chainId, account } = useWallet()

  const [poolList, setPoolList] = useState([])
  const [loading, setLoading] = useState(true)
  const networkId = useSelector(({ network }) => network.id)
  const wallet = useSelector(({ user }) => user.wallet)

  const getActivePoolData = async () => {
    if (!account) return
    setLoading(true)
    try {
      const poolList = await getContributedPoolList(networkId || chainId, account)
      if (_isMounted.current) {
        if (poolList?.result) {
          const uniqPools = uniqBy(poolList?.response, 'token')
          setPoolList(uniqPools)
          dispatch(saveActivePools({ chainId, pools: uniqPools }))
        } else {
          setPoolList([])
          dispatch(saveActivePools({ chainId, pools: [] }))
        }
      }
    } catch (err) {
      if (_isMounted.current) {
        setPoolList([])
      }
    }
    if (_isMounted.current) {
      setLoading(false)
    }
  }

  useEffect(() => {
    return () => {
      _isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (account) {
      initialFetch && getActivePoolData()
    } else if (!wallet) {
      setPoolList([])
      setLoading(false)
    }
  }, [account, chainId])

  return { poolList, loading, getActivePoolData }
}

export default useContributedPoolList
